import {
  getWorkflowIconsFromFeatures,
  type WorkflowActionFeature,
} from 'marketplace-ui-common/workflow-templates/getWorkflowIconsFromFeatures';
import { type WorkflowTemplateIcon } from 'marketplace-ui-common/workflow-templates/WorkflowTemplateIconGroup';
import { ProductFeatureCard } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';

function toWorkflowActionFeature(
  feature: ProductFeatureCard
): WorkflowActionFeature | null {
  if (feature.type !== 'WORKFLOW_ACTION') {
    return null;
  }

  return {
    name: feature.name,
    orderIndex: feature.metadata?.orderIndex,
    iconUrl: feature.metadata?.iconUrl,
    iconActionType: feature.metadata?.iconActionType,
    actionTypeId: feature.metadata?.actionTypeId,
  };
}

export function getWorkflowIconsFromProductFeatures(
  productFeatures: ProductFeatureCard[] = []
): WorkflowTemplateIcon[] {
  const features = productFeatures
    .map(toWorkflowActionFeature)
    .filter((feature): feature is WorkflowActionFeature => feature !== null);

  return getWorkflowIconsFromFeatures(features);
}
